import state from './moduleOperationListState.js'
import mutations from './moduleOperationListMutations.js'
import actions from './moduleOperationListActions.js'
import getters from './moduleOperationListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

